import format from 'date-fns/format';
import { useContext } from 'preact/hooks';
import TranslationContext from '../components/translations/translationContext';

const useDateFormat = (isoDateFormattedString: string, dateFormatTransKey: string): string => {
    const translations = useContext(TranslationContext);

    const dateFormat = translations.hasOwnProperty(dateFormatTransKey)
        ? translations[dateFormatTransKey]
        : "hh:mmaaaaa'm', dd-MM";

    try {
        return format(Date.parse(isoDateFormattedString), dateFormat);
    } catch {
        console.error('unsupported date format received by the useDateFormat hook');
        return 'invalid date';
    }
};

export default useDateFormat;
